jQuery(function($){
      /* Gallery Slider */
        $('.product-single__thumbnails-slider-track').find('.product-single__thumbnails-item').each(function(i){
        var num = (i%100) + 1; // mod function - returns the remainder
        $(this)
        .addClass('product-thumb-' + num )
    });
});

/* Input Appear */
	$("#options").change(function(){
		if($(this).val() == 'Yes Engraving Required') {
        	$('#extra-inputs').toggle();
        } else {
        	$('#extra-inputs').hide();
        }
    });